module.exports = __webpack_public_path__ + "img/112.03f43002.jpg";